import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Home2 from "./Home2";
import Type from "./Type";
import './Home.css'; 
import bg from "../../Assets/bg.png";

function Home() {

  const spans = document.querySelectorAll('.word span');

  spans.forEach((span, idx) => {
    span.addEventListener('click', (e) => {
      e.target.classList.add('active');
    });
    span.addEventListener('animationend', (e) => {
      e.target.classList.remove('active');
    });
    

    setTimeout(() => {
      span.classList.add('active');
    }, 750 * (idx+1))
  });





  return (
    <section>
      <Container fluid className="" id="home">
        <Container className="home-content">
          <Row>
            <Col md={7} className="home-header">
              <h1 style={{ paddingBottom: 15 }} className="heading">
              Hi!{" "}
                <span className="wave" role="img" aria-labelledby="wave">
                  👋🏻
                </span>
              </h1>

              <h1 className="heading-name">
               
                <strong className="main-name"> 
                <span>
                I'm



                <div class="word">
                  
	<span>J</span>
	<span>I</span>
	<span>M</span>
	<span>S</span>
	<span>O</span>
	<span>N</span>
  <span> </span> 
  <span>M</span>
	<span>O</span>
	<span>N</span>
	<span>T</span>
	<span>E</span>
	<span>D</span>
  <span>E</span>
	<span>R</span>
	<span>A</span>
	<span>M</span>
	<span>O</span>
	<span>S</span>


</div>
                
                
                
                
                
                
</span>
                </strong>
              </h1>

              <div style={{ padding: 50, textAlign: "left" }}>
                <Type />
              </div>
            </Col>

            <Col md={5} style={{ paddingBottom: 20 }}>

            <img
      src={bg}
      alt="home pic"
      className="img-fluid heartbeat-image"
      style={{ maxHeight: "450px" }}
    />

            </Col>
          </Row>
        </Container>
      </Container>
      <Home2 />
    </section>
  );
}

export default Home;
